
import useLanguage from "@/store/useLanguage";
import useConnectWallet from "@/store/wallet/useConnectWallet";
import { useConnectWalletInt } from "@/store/wallet/useConnectWalletInt";
import useHasReferrer from "@/web3Hook/useHasReferrer";
import { Dropdown, MenuProps } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import logo from "@/image/logo.svg";
import RouterPC from "./component/RouterPC";
import languageSVG from "@/image/languageSVG.svg";
import { languageItems } from "@/collocate";
import dropdownpfeil from "@/image/dropdownpfeil.svg";
import { mobileHidden } from "@/utils";
import { useState } from "react";
import HeaderModal from "./component/HeaderModal";
import useAddressConvert from "@/hooks/useAddressConvert";

const Header = () => {
  useConnectWalletInt()
  const { connectWalletStore, address } = useConnectWallet()
  const { setLanguage } = useLanguage()
  const { t, i18n } = useTranslation();
  // 地址转换
  // 地址转换
  const { addressConvert } = useAddressConvert();
  useHasReferrer();
  // 控制弹窗的参数
  const [isModalOpen, setIsModalOpen] = useState(false);
  // 初始化路由
  const navigate = useNavigate();
  // 打开弹窗
  const showModal = () => {
    setIsModalOpen(true);
  };
  // 改变语言
  const changeLanguage: MenuProps["onClick"] = ({ key }) => {
    i18n.changeLanguage(key);
    setLanguage(key)
  };
  return (
    <div className="flex items-center justify-between pt-4.5 px-4.5 z-50 relative" >
      <div className="flex items-center">
        <div className="flex items-center ">
          <img onClick={() => { navigate('/') }} className="w-7.5 mr-2.5" src={logo} alt="logo" />
          <span className="text-white text-lg font-black">
            NFX
          </span>
        </div>
        <RouterPC />
      </div>
      <div className="flex items-center">
        <Dropdown
          trigger={['click']}
          menu={{ items: languageItems, onClick: changeLanguage }}
          placement="bottomRight"
          arrow
        >
          <div className=" flex items-center border-1 border-green435 p-1 rounded-md mr-3">
            <img className="w-7 cursor-pointer" src={languageSVG} alt="language" />
          </div>
        </Dropdown>
        {!address ? <div onClick={() => {
          connectWalletStore();
        }} className="rounded-lg border border-d5 py-2 px-2.5 text-xs text-white flex items-center cursor-pointer">
          <span>{t('header.connectWallet')}</span>
          <img className="w-3.5 h-3.5" src={dropdownpfeil} alt="" />
        </div> :
          <div onClick={() => { showModal() }} className="rounded-lg border border-d5 py-1 px-2.5 text-xs text-white flex items-center cursor-pointer">
            <span className=" bg-white rounded text-black p-1">{mobileHidden(addressConvert(address), 5, 4)}</span>
            <img className="w-3.5 h-3.5 ml-1" src={dropdownpfeil} alt="" />
          </div>
        }
      </div>
      <HeaderModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </div>
  );
};

export default Header;